import { ArrowUp, ChevronDown, ChevronLeft, Edit, MoreVertical, Trash2 } from "react-feather";
import styles from "./complaintdetailsmobile.module.css";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { forwardRef } from "react";
import { TableLoaderSmall } from "../../../../components/LoaderC";
import HistoryMobile from "./HistoryMobile";
import CommentMobile from "./CommentMobile";
import RequestMobile from "./RequestMobile";

const OpenedToggleReadOnly = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Open}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Open</button>));

const ResolvedToggleReadOnly = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Resolved}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Resolved</button>));

const CancelledToggleReadOnly = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Cancelled}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Cancelled</button>));

const OpenedToggle = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Open}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Open <ChevronDown className={`${styles.DownArrowStatus}`} /></button>));

const ResolvedToggle = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Resolved}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Resolved <ChevronDown className={`${styles.DownArrowStatus}`} /></button>));

const CancelledToggle = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Cancelled}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Cancelled <ChevronDown className={`${styles.DownArrowStatus}`} /></button>));

const ComplaintDetailsMobile = ({ complaintData, setDelModalOpen, setEditModalOpen, changeCStatus, setComplaintData, setLoading, setSnackbarMsg, setSnackbarOpen }) => {
    const { user, isAuthenticated } = useAuth0();
    const [active, setActive] = useState("two");
    const [complaintImage, setComplaintImage] = useState('/static/img/other.svg');

    const toggle = (name) => {
        setActive((prev) => (prev === name ? null : name));
    }

    useEffect(() => {
        if (complaintData) {
            if (complaintData?.category === 'Noise')
                setComplaintImage('/static/img/noise.svg');
            else if (complaintData?.category === 'Garbage Removal')
                setComplaintImage('/static/img/garbage.svg');
            else
                setComplaintImage('/static/img/other.svg');
        }
    }, [complaintData]);

    return (<>
        {!complaintData && (<div className="Loader TableLoader">
            <TableLoaderSmall />
        </div>)}
        {complaintData && <div className={`${styles.UserMainDiv}`}>
            <Link className={`${styles.BackAddBU}`} to={"/request/complaints"}><ChevronLeft /></Link>
            {(isAuthenticated && (user['https://propertydek.com/permissions'].indexOf('complaint:update') > -1 || user['https://propertydek.com/permissions'].indexOf('complaint:delete') > -1)) && <Dropdown className={`${styles.ProEditSec}`}>
                <Dropdown.Toggle className={`${styles.EditActionsBU} ProsDrBU`} id="dropdown-basic">
                    <MoreVertical />
                </Dropdown.Toggle>

                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                    {user['https://propertydek.com/permissions'].indexOf('complaint:update') > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setEditModalOpen(true)}>
                        <Edit /> Edit
                    </Dropdown.Item>}
                    {user['https://propertydek.com/permissions'].indexOf('complaint:delete') > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => setDelModalOpen(true)}>
                        <Trash2 /> Delete
                    </Dropdown.Item>}
                </Dropdown.Menu>
            </Dropdown>}
            <div className={`${styles.DetailTopSec}`}>
                <div className={`${styles.DetailTopImgSec}`}>
                    <img src={complaintImage} class={`${styles.IMG}`} alt="" />
                </div>
                <div className={`${styles.DetailTopConSec}`}>
                    <p className={`${styles.Title}`}>{complaintData?.title}</p>
                    <div className={`${styles.MainReCardIdStatus}`}>
                        <p className={`${styles.MainReID}`}>{complaintData?.tenant_name} <span>{complaintData?.apt_name}</span></p>
                        <div className={`${styles.MainReqConDropBU}`}>
                            {!(isAuthenticated && user['https://propertydek.com/permissions'].indexOf('complaint:update') > -1) && <Dropdown>
                                {complaintData?.current_status === 0 && <Dropdown.Toggle as={OpenedToggleReadOnly} />}
                                {complaintData?.current_status === 2 && <Dropdown.Toggle as={ResolvedToggleReadOnly} />}
                                {complaintData?.current_status === 3 && <Dropdown.Toggle as={CancelledToggleReadOnly} />}
                            </Dropdown>}
                            {(isAuthenticated && user['https://propertydek.com/permissions'].indexOf('complaint:update') > -1) && <Dropdown>
                                {complaintData?.current_status === 0 && <Dropdown.Toggle as={OpenedToggle} />}
                                {complaintData?.current_status === 2 && <Dropdown.Toggle as={ResolvedToggle} />}
                                {complaintData?.current_status === 3 && <Dropdown.Toggle as={CancelledToggle} />}
                                <Dropdown.Menu className="DropDownMenuBoxCus">
                                    <Dropdown.Item className="DropDListWIcon" onClick={(e) => changeCStatus(complaintData, 0)}>Open</Dropdown.Item>
                                    <Dropdown.Item className="DropDListWIcon" onClick={(e) => changeCStatus(complaintData, 2)}>Resolved</Dropdown.Item>
                                    <Dropdown.Item className="DropDListWIcon" onClick={(e) => changeCStatus(complaintData, 3)}>Cancelled</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>}
                        </div>
                    </div>
                    <div className={`${styles.MainReCardIdStatusTwo}`}>
                        <p className={`${styles.MainReDate}`}>Submitted {dayjs(complaintData?.created_at).fromNow()}</p>
                        {complaintData?.priority === 1 && <p className={`${styles.ReffStatus} ${styles.Low}`}>
                            <ArrowUp />
                            <span>Low</span>
                        </p>}
                        {complaintData?.priority === 2 && <p className={`${styles.ReffStatus} ${styles.Medium}`}>
                            <ArrowUp />
                            <span>Medium</span>
                        </p>}
                        {complaintData?.priority === 3 && <p className={`${styles.ReffStatus} ${styles.High}`}>
                            <ArrowUp />
                            <span>High</span>
                        </p>}
                    </div>
                </div>
            </div>
            <div className={styles.AccordionSecMain}>

                <RequestMobile isPanelOpen={active === "two"} onToggle={() => toggle("two")} complaintData={complaintData} setComplaintData={setComplaintData.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} />

                <CommentMobile isPanelOpen={active === "four"} onToggle={() => toggle("four")} complaintData={complaintData} setComplaintData={setComplaintData.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} />

                <HistoryMobile isPanelOpen={active === "five"} onToggle={() => toggle("five")} histories={complaintData?.histories} />

            </div>
        </div>}
    </>
    );
}

export default ComplaintDetailsMobile;